import React from "react";
import ReactDOM from "react-dom";
import classNames from "classnames";
import { twClassNames } from "../helpers/twClassNames";

type LoadingSpinnerProps = { status?: string; message?: string };

export function LoadingSpinner({ status, message }: LoadingSpinnerProps) {
    const statusString = status || "Loading...";
    const detailString = message || "This may take a few seconds, please don't close this page.";

    return ReactDOM.createPortal(
        <div>
            <div className="fixed bottom-0 left-0 right-0 top-0 z-[99] h-screen w-full overflow-hidden bg-gray-700 opacity-75"></div>
            <div className="fixed bottom-0 left-0 right-0 top-0 z-[99] flex h-screen w-full flex-col items-center justify-center overflow-hidden">
                <div className="loader mb-4 h-12 w-12 rounded-full border-4 border-t-4 border-gray-200 ease-linear"></div>
                <h2 className="text-center text-xl font-semibold text-white">{statusString}</h2>
                <p className="w-1/3 text-center text-white">{detailString}</p>
            </div>
        </div>,
        document.getElementById("rf-portal-root")
    );
}

type InlineLoadingSpinnerProps = {
    text?: string;
    type?: "primary" | "secondary";
    universe?: boolean;
    className?: string;
    spinnerClassName?: string;
};

export function InlineLoadingSpinner({
    text = "",
    type = "primary",
    universe = false,
    className = undefined,
    spinnerClassName = undefined
}: InlineLoadingSpinnerProps) {
    return (
        <>
            {type === "primary" ? (
                <div className={twClassNames("flex items-center justify-center", className)}>
                    <div
                        className={twClassNames(
                            universe
                                ? "dark border-gray-700 border-t-aquavision-500"
                                : "border-gray-200 border-t-brand",
                            "loader h-10 w-10 rounded-full border-4 border-t-4 transition-all ease-linear",
                            spinnerClassName
                        )}
                        style={{ animation: "spinner 1.5s linear infinite" }}
                    ></div>
                    <div
                        className={classNames(
                            universe ? "text-gray-200" : "text-secondary",
                            "ml-4 font-medium"
                        )}
                    >
                        {text}
                    </div>
                </div>
            ) : (
                <div
                    className={twClassNames(
                        "flex w-full animate-pulse flex-col items-center justify-center gap-2",
                        className || ""
                    )}
                >
                    <i
                        className={classNames(
                            universe ? "text-aquavision-500" : "text-brand",
                            "fa-spin far fa-spinner text-2xl"
                        )}
                    ></i>
                    {text && (
                        <h1
                            className={twClassNames(
                                "text-base font-medium",
                                universe ? "text-gray-200" : "text-secondary"
                            )}
                        >
                            {text}
                        </h1>
                    )}
                </div>
            )}
        </>
    );
}
